export default {
  SET_PAGINATION(state, data) {
    state.pagination = data;
  },
  SET_PAYABLES(state, documents) {
    state.payables = documents;
  },
  SET_INVOICES(state, documents) {
    state.invoices = documents;
  },
  DELETE_INVOICE(state, itemId) {
    const certIndex = state.invoices.findIndex(u => u.id === itemId);
    state.invoices.splice(certIndex, 1);
  },
  SET_PRO_FORMA_INVOICES(state, data) {
    state.proFormaInvoices = data;
  },
  DELETE_PRO_FORMA_INVOICE(state, itemId) {
    const certIndex = state.proFormaInvoices.findIndex(u => u.id === itemId);
    state.proFormaInvoices.splice(certIndex, 1);
  },
  SET_CN_DNS(state, data) {
    state.cnDns = data
  },
  SET_CONSOLIDATED(state, data) {
    state.consolidated = data
  },
  SET_SELF_BILLED(state, data) {
    state.selfBilled = data
  },
  DELETE_CN_DN(state, itemId) {
    const certIndex = state.cnDns.findIndex(u => u.id === itemId);
    state.cnDns.splice(certIndex, 1);
  },
  // SET_DOCUMENT(state, document) {
  //   state.document = document;
  // },
  // ADD_DOCUMENT(state, document) {
  //   state.documents.push(document);
  // },
  // UPDATE_DOCUMENT(state, document) {
  //   const certIndex = state.documents.findIndex(
  //     e => e.id === document.id
  //   );
  //   Object.assign(state.documents[certIndex], document);
  // },
  DELETE_DOCUMENT(state, itemId) {
    const certIndex = state.documents.findIndex(u => u.id === itemId);
    state.documents.splice(certIndex, 1);
  },
  SET_COLLECTION_DASHBOARD(state, collection) {
    state.collection = collection;
  },
  SET_DASHBOARD_BILLINGDOCS_COUNT(state, billingdocsCount) {
    state.billingdocsCount = billingdocsCount;
  },
  SET_PRE_EINVOICE_CREATION_COUNT(state, preEinvoiceCreationCount) {
    state.preEinvoiceCreationCount = preEinvoiceCreationCount;
  },
  SET_DASHBOARD_SUMMARY(state, summary) {
    state.summary = summary;
  },
  DELETE_PF(state, itemId){
    const certIndex = state.proFormaInvoices.findIndex(u => u.id === itemId);
    state.proFormaInvoices.splice(certIndex, 1);
  },
  SET_ORDERS(state, documents) {
    state.orders = documents;
  },
  DELETE_ORDER(state, docNo) {
    const idx = state.orders.findIndex(u => u.docNo === docNo);
    if (idx >= 0) state.orders.splice(idx, 1);
  },
  SET_ORDER_SUMMARY(state, summary) {
    state.orderSummary = summary;
  },
};
